<app-modal-container
  [bigSize]="false"
  [title]="!investors.all.length ? 'Manage investors' : investors.valid.length + ' investor'
            + (investors.valid.length !== 1 ? 's' : '') + ' about to proceed'"
  [buttons]="modalButtons"
  (closeButtonClicked)="close()"
  data-qa="ca-manage-investors"
>
  <div class="centered-column-container column-gap-1">
    <app-switcher
      data-qa="ca-manage-investors-switcher"
      [leftText]="'Pull investors'"
      [rightText]="'Bulk upload'"
      [checked]="true"
      (checkedChanged)="switchUploadType()"
    >
    </app-switcher>
    <div *ngIf="!investors.all.length && bulkUpload">
      <div class="centered-row-container">
        <app-button
          data-qa="ca-manage-investors-download-template"
          class="button-font-1p09375"
          [type]="buttonsTypes.download"
          [size]="'medium'"
          [iconName]="'download-arrow-in-circle.svg'"
          (buttonClick)="downloadTemplate()" >
          Download template
        </app-button>
        <input
          class="display-none"
          type="file"
          id="fileInput"
          (change)="uploadData($event)"
          >
        <label for="fileInput">
          <app-button
            data-qa="ca-manage-investors-upload"
            class="button-font-1p09375"
            [type]="buttonsTypes.upload"
            [size]="'medium'"
            [iconName]="'upload-arrow-in-circle.svg'"
          >
            Upload data
          </app-button>
        </label>
      </div>
      <div class="modal-subtitle black-10">
        Download template with investors data and upload with yours.
      </div>
    </div>
    <div *ngIf="investors.all.length" class="width-35 table-fms vertical-container column-gap-0p5">
      <table>
        <colgroup>
          <col *ngIf="investors.invalid.length" span="1" class="width-5pcnt" />
          <col span="1" class="width-45pcnt" />
          <col span="1" class="width-45pcnt" />
          <col span="1" class="width-5pcnt" />
        </colgroup>
        <thead>
        <tr class="not-clickable">
          <th *ngIf="investors.invalid.length"></th>
          <th>
            <div class="start-column-container">
              <div> Investor </div>
              <div *ngIf="!bulkUpload" class="caption-2 bold500 black-10"> Capital call tracker </div>
            </div>
          </th>
          <th>Commitment</th>
          <th></th>
        </tr>
        </thead>

        <tbody>

        <!-- valid investors -->

        <tr *ngIf="investors.invalid.length" class="bg-black-1">
          <td class="clickable" (click)="show.valid = !show.valid">
            <app-table-group-icon [opened]="show.valid"></app-table-group-icon>
          </td>
          <td colspan="3">
          <span class="light-bold">
            Valid investors <span class="black-10 bg-black-3 dot"> {{ investors.valid.length }} </span>
          </span>
          </td>
        </tr>
        <ng-container *ngIf="show.valid">
          <ng-container *ngFor="let investor of investors.valid">
            <ng-template [ngTemplateOutlet]="investorTemplate" [ngTemplateOutletContext]="{investor: investor, isInvalid: false}"></ng-template>
          </ng-container>
        </ng-container>


        <!-- invalid investors -->

        <tr *ngIf="investors.invalid.length" class="bg-black-1">
          <td class="clickable" (click)="show.invalid = !show.invalid">
            <app-table-group-icon [opened]="show.invalid"></app-table-group-icon>
          </td>
          <td colspan="3">
            <div class="space-between-horizontal-align row-gap-0p25 light-bold">
              <span> Invalid investors <span class="black-10 bg-black-3 dot"> {{ investors.invalid.length }} </span> </span>
              <app-button
                data-qa="ca-manage-investors-remove-all-invalid"
                [type]="'light-red'"
                [size]="'xsmall'"
                [iconName]="'delete.svg'"
                (buttonClick)="removeInvalidInvestors()"
              >
                Delete all
              </app-button>
            </div>
          </td>
        </tr>

        <ng-container *ngIf="show.invalid">
          <ng-container *ngFor="let investor of investors.invalid">
            <ng-template [ngTemplateOutlet]="investorTemplate" [ngTemplateOutletContext]="{investor: investor, isInvalid: true}"></ng-template>
          </ng-container>
        </ng-container>

        <tr class="total first-level-bottom-sticky light-bold">
          <td *ngIf="investors.invalid.length"></td>
          <td>Total</td>
          <td> {{ totalCommitment | switcherDashBraces : switcher : 0 }} </td>
          <td></td>
        </tr>
        </tbody>
      </table>
      <div class="flex-center">
        <app-button
          data-qa="ca-manage-investors-save-investors"
          class="button-font-1p09375"
          [type]="'accent'"
          [size]="'medium'"
          [disabled]="!canUpload"
          (buttonClick)="storeInvestors()"
        >
          Continue
        </app-button>
      </div>
    </div>
  </div>
</app-modal-container>

<!-- Investor Row Template -->
<ng-template #investorTemplate let-investor="investor" let-isInvalid="isInvalid">
  <tr [class.red-10]="isInvalid">
    <td *ngIf="investors.invalid.length"></td>
    <td>
      <div class="start-column-container">
        <div class="font-4">{{ investor.name }}</div>
        <div class="caption-2 bold500" [class.black-10]="!isInvalid">ID: {{ investor.code }} <span class="black-10 bg-black-3 dot" *ngIf="investor.isGP"> GP </span></div>
      </div>
    </td>
    <td>{{ investor.commitment | switcherDashBraces : switcher : 0 }}</td>
    <td>
      <div class="clickable flex-center">
        <app-all-icons
          [attr.data-qa]="'ca-manage-investors-remove-investor-' + investor.code"
          class="icon-container"
          [iconNameAndStyling]="'delete.svg'"
          (click)="removeInvestor(investor)"
        >
        </app-all-icons>
      </div>
    </td>
  </tr>
</ng-template>
